// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts';
export let DirectEntitlementProductMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_PFIX_PRODUCT_MESSAGE)

    this.Id = -1;
    this.Name = null;
    this.Description = null;
    this.Category = null;
    this.CurrencyId = null;
    this.ProPrice = null;
    this.NonProPrice = null;
    this.HasDocument = null;
    this.ImageBytes = null;
    this.ProductDefinitions = null;
    this.IsUnsubscribeAllowed = null;
    this.IsActive = null;
    this.ProductDataType = null;
    this.ShowInSettings = null;
    this.ColorHEX = null;
}

DirectEntitlementProductMessage.prototype = Object.create(DirectMessageBase.prototype)